var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.857,
    height: 31.857,
    viewBox: "0 0 31.857 31.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 31.857,
    height: 31.857,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(31.857 31.857) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M10.672,6.434a.874.874,0,0,0-.617.255L5.561,11.183a.872.872,0,1,0,1.232,1.234L10.672,8.54l3.879,3.877a.872.872,0,0,0,1.232-1.234l-4.5-4.494a.87.87,0,0,0-.615-.255",
    transform: "translate(5.257 6.375)",
    fill: "#231f20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandTick);
export default __webpack_public_path__ + "static/media/expand_tick.a7c322ab0020acce4359e97e6f00c411.svg";
export { ForwardRef as ReactComponent };